<template>
  <edit-field ref="NUMERO_OBJET_CODE"
              :value=value
              :contextId=contextId
              :editFieldInfo=editFieldInfo
              :min=min
              :max=max
              :hideLabel='hideLabel'
              :dataTable='dataTable'
              :required=required
              :disabled=readOnly
              :showMissing=showMissing
              :over-ride-placeholder=overRidePlaceholder
              @updated=setUpdated
              @context=setInitValue
              @error=setError>
  </edit-field>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import EditBase from '@/framework/base/components/EditBase';
  import EditField from '@/framework/base/components/EditField.vue'
  import { EditFieldType, FieldInfo, getFormat } from '@/framework/base/components/FieldInfo'
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';
  // eslint-disable-next-line
  import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';

  export default defineComponent({
    extends: EditBase,
    components: {
      EditField
    },
    props: {
      overRidePlaceholder: {
        type: String
      }
    },
    computed: {
      ressource () { return RessourceGenControl(GenControl.NUMERO_OBJET_CODE); },
      editFieldInfo (): FieldInfo {
        const type = EditFieldType.STRING;
        const precision = 2;
        const format = getFormat('UPPERCASE');
        const focus = this.focusValidator;
        const live = this.liveValidator;
        const mask = this.mask;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
      }
    },
    methods: {
      // eslint-disable-next-line
      focusValidator (value: string): validator | null {
        return  null;
      },

      // eslint-disable-next-line
      liveValidator (value: string): validator | null {
        return new validator(rules.objetPoleEmploi, RULES_FRENCH_LABEL.text.objetPoleEmploi.error);
      },

      // eslint-disable-next-line
      mask (value: string): string {
        return 'NN XA NNNNNN NN';
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.NUMERO_OBJET_CODE.missing();
      },

      touch (): void {
        // @ts-expect-error : generated method
        this.$refs.NUMERO_OBJET_CODE.touch();
      },

      setFocus (): void {
        // @ts-expect-error : generated method
        this.$refs.NUMERO_OBJET_CODE.setFocus();
      }
    }
  })
</script>
